/**
 * @file SystemMessagesService Service
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { Router, NavigationEnd } from '@angular/router';
import * as moment from 'moment';
import { AbstractBase } from '../core/helpers/abstract-base';
/**
 * SystemMessagesService Service
 */
var SystemMessagesService = /** @class */ (function (_super) {
    tslib_1.__extends(SystemMessagesService, _super);
    /**
     * Constructs a SystemMessagesService instance.
     * @param router The router
     */
    function SystemMessagesService(router) {
        var _this = _super.call(this) || this;
        /** Array of system messages */
        _this.systemMessages = [];
        _this.subscriptionPool.add(router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.cleanUp();
            }
        }));
        return _this;
    }
    /**
     * Add a system message
     * @param id The id of the system message
     * @param variant The variant (success, info, warning, danger)
     * @param subject The subject (visible in bold)
     * @param message The message of the system message
     * @param start Message is visible from start
     * @param finish Message is visible until finish
     */
    SystemMessagesService.prototype.add = function (id, variant, subject, message, start, finish) {
        // Create new system message
        var newSystemMessage = {
            id: id,
            variant: variant,
            subject: subject,
            message: message,
            start: (start) ? start : moment(),
            finish: (finish) ? finish : moment().add(1, 'minute'),
        };
        // Check if new system message already exists
        var result = this.systemMessages.find(function (systemMessage) { return systemMessage.id === newSystemMessage.id; });
        // Only add system message if unique
        if (!result) {
            this.systemMessages.push(newSystemMessage);
        }
    };
    /**
     * Retrieving system messages
     * @returns The system messages
     */
    SystemMessagesService.prototype.get = function () {
        // Prevent flickering in DOM (because next step give always a new reference)
        if (this.systemMessages.length === 0) {
            return this.systemMessages;
        }
        // Search for relevant system messages
        var now = moment();
        var systemMessages = this.systemMessages.filter(function (systemMessage) {
            return (now.isBetween(systemMessage.start, systemMessage.finish));
        });
        return systemMessages;
    };
    /**
     * Clean up the system messages items
     */
    SystemMessagesService.prototype.cleanUp = function () {
        var now = moment();
        this.systemMessages = this.systemMessages.filter(function (systemMessage) {
            return (now.isBefore(systemMessage.finish));
        });
    };
    /**
     * Delete a system message
     * @param id The id of the system message
     */
    SystemMessagesService.prototype.delete = function (id) {
        this.systemMessages = this.systemMessages.filter(function (systemMessage) {
            return (systemMessage.id !== id);
        });
    };
    return SystemMessagesService;
}(AbstractBase));
export { SystemMessagesService };
